<!--
 * @Author: cryi.liu
 * @Date: 2020-06-11 14:13:19
 * @LastEditTime: 2020-06-18 11:45:32
 * @Description: 填空题作答区域
-->
<template>
  <div class="text-area">
    <!-- <i-input
      v-for="(i, index) in len"
      :key="index"
      :value="userAnswers[index]"
      @on-change="textInputChanged(index, $event)">
      <div class="index" slot="prefix">{{ index + 1 }}、</div>
    </i-input> -->

    <div
      v-for="(i, index) in len"
      :key="i"
      class="text-area-item"
      :class="focus[index] ? 'active' : ''">
      <span class="prefix">{{ i }}</span>
      <input type="text"
        :value="userAnswers[index]"
        @input="textInputChanged(index, $event)"
        @focus="textInputFocus(index)"
        @blur="textInputBlur(index)" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { debounce } from '../../../../../utils';

export default {
  name: 'TextArea',
  props: {
    type: { type: String, required: true },
    index: { type: Number, required: true },
    timeRemaining: { type: String, required: true },
  },
  data() {
    return {
      len: 0,
      userAnswers: [],
      focus: [],
    };
  },
  computed: {
    ...mapGetters({
      libraryInfo: 'onlineExamStore/libraryInfo',
    }),
    question() {
      return this.libraryInfo[this.index];
    },
    options() {
      return this.question.libraryVo.options;
    },
    answer() {
      return this.question.answer;
    },
    title() {
      return this.question.libraryVo.content;
    },
  },
  watch: {
    title: {
      immediate: true,
      handler(title) {
        const tempArr = title.split('[]');
        this.len = tempArr.length - 1;
        this.userAnswers = new Array(this.len).fill('');
      },
    },
    answer: {
      immediate: true,
      handler(answer) {
        if (answer) {
          this.userAnswers = answer.split(']');
        } else {
          this.userAnswers = [];
        }

        this.focus = new Array(this.userAnswers.length).fill(false);
      },
    },
  },
  methods: {
    ...mapActions({
      setLibraryInfo: 'onlineExamStore/invokeSetLibraryInfo',
    }),
    /**
     * 填空题输入框发生改变
     */
    textInputChanged(index, e) {
      this.$set(this.userAnswers, index, e.target.value);

      this.requestSaveAnswerAndSetting();
    },
    textInputFocus(index) {
      // this.focus = new Array(this.userAnswers.length).fill(false);

      this.$set(this.focus, index, true);
    },
    textInputBlur(index) {
      this.$set(this.focus, index, false);
    },
    /**
     * 请求保存答题信息并设置
     */
    requestSaveAnswerAndSetting: debounce(function () {
      this.requestSaveAnswer()
        .then(() => {
          const libraryInfo = JSON.parse(JSON.stringify(this.libraryInfo));

          libraryInfo[this.index].answer = this.userAnswers.join(']');

          this.setLibraryInfo({ libraryInfo });
        })
        .catch((result) => {
          alert(result.msg);

          if (result.msg === '您已在另一终端进入考试') {
            window.open('/mvc/page?loc=portal/gate&locale=zh&skipRefer=1', '_self');
          }
        });
    }, 500),
    /**
     * 请求保存答题信息
     */
    requestSaveAnswer() {
      const params = {
        id: this.question.id,
        answer: this.userAnswers.join(']'),
        remainingTime: this.timeRemaining,
      };

      return new Promise(async (resolve, reject) => {
        const result = await this.$http.answer.saveAnswer(params);
        if (result.code === '200') {
          resolve(result);
        } else {
          reject(result);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.text-area {
  margin-top: 12px;
  width: 100%;

   &-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 420px;
    margin-bottom: 12px;
    padding: 8px 12px;
    background-color: rgba(12, 140, 202, 0.08);
    color: #0C8CCA;
    border-radius: 4px;
    font-size: 14px;
    overflow: hidden;

    &.active {
      position: relative;
      background-color: rgba(12, 140, 202, 0.08);
      color: #0C8CCA;

      &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border: 1.2px solid #0C8CCA;
        border-radius: 4px;
      }

      > .suffix {
        display: block;
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    .prefix {
      margin-right: 12px;
      font-weight: bold;
    }

    input {
      flex: 1;
      background-color: transparent;
      border: none;
      outline: none;
    }
  }

  // /deep/ .ivu-input-wrapper {
  //   margin-bottom: 20px;

  //   &:last-of-type {
  //     margin-bottom: 0;
  //   }
  // }

  // /deep/ .ivu-input-prefix {
  //   width: 48px;
  // }

  // .index {
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   width: 100%;
  //   height: 100%;
  // }
}
</style>
